<div class="machine-info-widget">
    <div class="row">
        <div class="col col-lg-6">
            <span>Machine Name:</span>
        </div>
        <div class="col col-lg-6">
            <span></span>{{ machineInfo.Name }}
        </div>
    </div>
    
    <div class="row">
        <div class="col col-lg-6">
            <span>Machine Fenix Version:</span>
        </div>
        <div class="col col-lg-6">
            <span>{{ machineInfo.FenixVersion }}</span>
        </div>
    </div>
    
    <div class="row">
        <div class="col col-lg-6">
            <span>Machine Owner:</span>
        </div>
        <div class="col col-lg-6">
            <span>{{ getTranslateOwnerIdToName(machineInfo.OwnerId) }}</span>
        </div>
    </div>
    
    <div class="row">
        <div class="col col-lg-6">
            <span>Status:</span>
        </div>
        <div class="col col-lg-6">
            <span>{{ machineInfo.CurrentStatus }}</span>
        </div>
    </div>
    
    <div class="mt-3">
        <dx-button text="Go to detail" (click)="goToDetail()"></dx-button>
    </div>
    
    <div class="structure-container mt-3">
        <machine-structure-tree-list [machineName]="options?.machineName ?? undefined"></machine-structure-tree-list>
    </div>
</div>